export enum IconSize {
  small = 15,
  medium = 30,
  large = 45,
}
